/**
 * Tab
 *
 */
export default class Tab {
  constructor(selector, options) {
    this.wrapper = selector;
    this.options = {
      prefix: 'pfx-',
      buttonItemClass: '.js-tab-list-button',
      isActiveClass: 'is-active',
      ...options,
    };
  }

  init() {
    if (this.wrapper.classList.contains('plugin-tab-initialized')) return;
    this.checkActiveClass();
    this.addListeners();
    this.wrapper.classList.add('plugin-tab-initialized');
  }

  checkActiveClass() {
    const buttons = this.getButtonItems();

    const activeElement = buttons.find(
      (button) =>
        button.classList.contains(this.options.isActiveClass) ||
        button.parentNode.classList.contains(this.options.isActiveClass),
    );

    if (!activeElement) {
      if (buttons[0]) {
        const target = buttons[0].getAttribute('href');
        buttons[0].classList.add(this.options.isActiveClass);
        buttons[0].parentNode.classList.add(this.options.isActiveClass);

        if (target) {
          const targetEl = document.querySelector(target);

          if (targetEl) {
            targetEl.classList.add(this.options.isActiveClass);
          }
        }
      }
    } else {
      const target = activeElement.getAttribute('href');

      if (target) {
        const targetEl = document.querySelector(target);

        if (targetEl) {
          targetEl.classList.add(this.options.isActiveClass);
        }
      }
    }
  }

  addListeners() {
    const buttons = this.getButtonItems();

    buttons.forEach((button) => {
      const target = button.getAttribute('href');

      if (target) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          //button.innerHTML = 'AA';
          this.removeActiveClasses();
          button.classList.add(this.options.isActiveClass);
          button.parentNode.classList.add(this.options.isActiveClass);

          const targetEl = document.querySelector(target);

          if (targetEl) {
            targetEl.classList.add(this.options.isActiveClass);
          }
        });
      }
    });
  }

  removeActiveClasses() {
    const buttons = this.getButtonItems();

    buttons.forEach((button) => {
      const target = button.getAttribute('href');

      if (target) {
        const targetEl = document.querySelector(target);
        button.classList.remove(this.options.isActiveClass);
        button.parentNode.classList.remove(this.options.isActiveClass);

        if (targetEl) {
          targetEl.classList.remove(this.options.isActiveClass);
        }
      }
    });
  }

  getButtonItems() {
    return Array.from(this.wrapper.querySelectorAll(this.options.buttonItemClass));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const selectors = Array.from(document.querySelectorAll('.js-tab-list'));
  selectors.forEach((selector) => {
    new Tab(selector).init();
  });
});
